import { Box, Button, Card, Select, SxProps, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/system';


type GenericStyledBoxProps = {
  sx?: SxProps,
  children?: JSX.Element | string,
  className?: string,
  variant?: string
};

const genericStyles = {
  fontFamily: 'Schibsted Grotesk',
  fontSize: '14px',
  fontWeight: 500,
};



const GenericStyledBox = ({ sx, children }: GenericStyledBoxProps) => {

  return (
    <Box sx={{
      fontFamily: 'Schibsted Grotesk',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '125%',
      color: 'var(--ri-grey-white-background)',
      ...sx,
    }}>
      {
        children
      }
    </Box>
  );
};

const useCardStyles = makeStyles((theme: Theme) => ({
  card: {
    [theme.breakpoints.down(3000)]: {
      maxWidth: '60%',
    },
    [theme.breakpoints.down('lg')]: {
      maxWidth: '40%',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '800px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
}));

const useInformedIndividualCardStyles = makeStyles((theme: Theme) => ({
  card: {
    [theme.breakpoints.down(3000)]: {
      maxWidth: '50%',
    },
    [theme.breakpoints.down('xl')]: {
      maxWidth: '60%',
    },
    [theme.breakpoints.down('lg')]: {
      maxWidth: '40%',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '800px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
}));


const SelectWrapper = styled(Select)(() => ({
  marginTop: '12px',
  color: 'var(--ri-grey-white-background) !important',
  '& .MuiInputLabel-formControl': {
    fontFamily: 'Schibsted Grotesk',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    color: 'var(--ri-grey-white-background) !important',
  },
  '& .MuiInput-underline:before, & .MuiInput-underline:hover:before': {
    borderBottom: '1px solid var(--ri-input-border-color)',
  },
  '&:before': {
    borderBottom: '1px solid var(--ri-input-border-color)',
  },
  height: '3.5rem',
  overflow: 'hidden',
  paddingLeft: '0.5rem',
  paddingRight: '0.5rem',
  borderRadius: '6px',
  backgroundColor: 'rgba(0, 0, 0,0.03)',
}));


const ButtonActionWrapper = styled('div')(() =>({
  position: 'relative',
  background: 'linear-gradient(90deg, rgba(36,73,252,1) 0%, rgba(0,206,207,1) 35%, rgba(0,206,207,1) 100%)',
  padding: '2px',
  borderRadius: '4px',
}));

const TypographyWrapper = styled(Typography)(() =>({
  ...genericStyles,
  color: '#181818',
}));



const ButtonAction = styled(Button)(() => ({
  ...genericStyles,
  fontWeight: 600,
  color: '#181818',
  textTransform: 'none',
  paddingLeft: '20px',
  paddingRight: '20px',
  background: '#FFFFFF',
  '&:hover': {
    background: '#FFFFFF',
  },
}));

const CardWrapper = ({ sx, children, className }: GenericStyledBoxProps) => {

  const cardClasses = useCardStyles();
  const additionalClassName = (typeof className == 'undefined') ? '' : className;
  return (<Card className={`${cardClasses.card} ${additionalClassName}`} variant="outlined" sx={{ m: 'auto', mt: '30px', minHeight: '250px', ...sx }}>{children}</Card>);
};

const InformedIndividualCardWrapper = ({ sx, children, className }: GenericStyledBoxProps) => {

  const cardClasses = useInformedIndividualCardStyles();
  const additionalClassName = (typeof className == 'undefined') ? '' : className;
  return (<Card className={`${cardClasses.card} ${additionalClassName}`} variant="outlined" sx={{ m: 'auto', mt: '30px', minHeight: '250px', ...sx }}>{children}</Card>);
};

const FormWrapper = styled(Box)(() =>({
  '& .borderErrorClass': {
    border: '1px solid red !important',
    '& label': {
      color: 'red !important',
    },
  },
  '& .textErrorClass': {
    color: 'red',
  },
}));

export {
  GenericStyledBox,
  CardWrapper,
  InformedIndividualCardWrapper,
  ButtonAction,
  ButtonActionWrapper,
  TypographyWrapper,
  SelectWrapper,
  FormWrapper,
  genericStyles,
};